import { Component, Inject } from '@angular/core';
import { consts } from '@src/constants/consts';
import { userActions } from '@src/store/reducers/userReducer';
import { Store } from '@src/store';

@Component({
    selector: 'user-roles-management',
    template: require('./userRolesManagement.html'),
    styles: [require('./_userRolesManagement.scss')]
})
export class UsersRolesManagementComponent {

    public item = { name: 'usersManagement', appLink: 'app.authorized.usersRolesManagement.usersManagement' }
    public canManageUsers: any
    public canManageUserGroups: any
    public vMenuExpanded: boolean = false



    constructor(@Inject('$state') private $state: any, private store: Store, @Inject('authorizationService') private authorizationService: any) {
        this.$state.go(this.item.appLink, this.item.name);
        this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.AddUser).then(canManageUsers => {
            setTimeout(() => {
                this.canManageUsers = canManageUsers;
            }, 50);
        });


        this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.AddUserGroup).then(canManageUserGroups => {
            setTimeout(() => {
                this.canManageUserGroups = canManageUserGroups;
            }, 50);
        });

        this.store.dispatch({
            type: userActions.GET_CURRENT_USER_DETAILS
        }).then((res: any) => {

            this.store.dispatch({
                type: userActions.GET_PERMISSIONS_FOR_USER,
                payload: {
                    userId: res.data.id
                }
            })
        });
    }


    public navigate(event: any, item: any) {
        if (!item.appLink) {
            return;
        }
        event.preventDefault();
        this.item = item
        this.$state.go(item.appLink, item.name);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/userRolesManagement-ang7.ts